module.exports = __webpack_public_path__ + "static/media/2014 Family Picture.8dd50735.jpg";